import { FC, lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import {
  AxiosHookConfigProvider,
  useAxiosHookConfig,
} from 'src/hooks/use-axios';
import { useExtendAxiosConfig } from 'src/pages/direct-fcfs/support/axios';
import {
  TsoMapProvider,
  useTsoMap,
} from 'src/pages/transport/fcfs-booking/direct/tso-link';
import { NotFound } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

const PageWithAxiosConfig: FC = () => {
  const global = useAxiosHookConfig();
  const axiosConfig = useExtendAxiosConfig(global);
  const tsoMap = useTsoMap();

  if (!tsoMap) return <PageSpinner />;

  return (
    <TsoMapProvider value={tsoMap}>
      <AxiosHookConfigProvider value={axiosConfig}>
        <Page />
      </AxiosHookConfigProvider>
    </TsoMapProvider>
  );
};

const PageIfEnpointConfigured: FC = () => {
  if (!PRISMA_CONFIG.directFcfs) throw new NotFound();

  return <PageWithAxiosConfig />;
};

export default PageIfEnpointConfigured;
